import React, { forwardRef } from 'react';

import AgGridReact from './AgGridReact.jsx';
import { ModuleRegistry } from 'ag-grid-community';
import { LicenseManager } from 'ag-grid-enterprise';

import { gridTheme } from './gridTheme.js';
import { parseZone } from '../../../helpers/parseZone.js';

import { ClientSideRowModelModule } from 'ag-grid-community';
import { ColumnMenuModule } from 'ag-grid-enterprise';
import { ContextMenuModule } from 'ag-grid-enterprise';
import { ExcelExportModule } from 'ag-grid-enterprise';
import { ServerSideRowModelModule } from 'ag-grid-enterprise';
import { ClipboardModule } from 'ag-grid-enterprise';
import { ColumnsToolPanelModule } from 'ag-grid-enterprise';
import { FiltersToolPanelModule } from 'ag-grid-enterprise';
import { CellSelectionModule } from 'ag-grid-enterprise';
import { RichSelectModule } from 'ag-grid-enterprise';
import { RowGroupingModule } from 'ag-grid-enterprise';
import { RowGroupingPanelModule } from 'ag-grid-enterprise';
import { SetFilterModule } from 'ag-grid-enterprise';
import { MultiFilterModule } from 'ag-grid-enterprise';
import { SideBarModule } from 'ag-grid-enterprise';
import { StatusBarModule } from 'ag-grid-enterprise';
import { CsvExportModule } from 'ag-grid-community';
import { AdvancedFilterModule } from 'ag-grid-enterprise';
import { IntegratedChartsModule } from 'ag-grid-enterprise';
import { ColumnAutoSizeModule } from 'ag-grid-enterprise';
import { ColumnApiModule } from 'ag-grid-community'; 
import { ValidationModule } from 'ag-grid-enterprise';
import { DateFilterModule } from 'ag-grid-community'; 
import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';
import { CellStyleModule } from 'ag-grid-community';
import { TextFilterModule } from 'ag-grid-community';
import { NumberFilterModule } from 'ag-grid-community';
import { ServerSideRowModelApiModule } from 'ag-grid-enterprise'; 
import { RowApiModule } from 'ag-grid-community';
import { PaginationModule } from 'ag-grid-community';
import { PinnedRowModule } from 'ag-grid-community'; 
import { RowAutoHeightModule } from 'ag-grid-community';
import { EventApiModule } from 'ag-grid-community';
import { TextEditorModule } from 'ag-grid-community'; 
import { LargeTextEditorModule } from 'ag-grid-community';
import { CustomEditorModule } from 'ag-grid-community';
import { SelectEditorModule } from 'ag-grid-community'; 
import { RowSelectionModule } from 'ag-grid-community';
import { ExternalFilterModule } from 'ag-grid-community'; 
import { ClientSideRowModelApiModule } from 'ag-grid-community'; 
import { QuickFilterModule } from 'ag-grid-community';
import { PivotModule } from 'ag-grid-enterprise';
import { RenderApiModule } from 'ag-grid-community';
import { LocaleModule } from 'ag-grid-community';
import { CellApiModule } from 'ag-grid-community';
import { RowDragModule } from 'ag-grid-community';
import { InfiniteRowModelModule } from 'ag-grid-community';
import { UndoRedoEditModule } from 'ag-grid-community';
import { BatchEditModule } from 'ag-grid-enterprise';
import { RowStyleModule } from 'ag-grid-community';
import { ScrollApiModule } from 'ag-grid-community';
import { GridStateModule } from 'ag-grid-community'

ModuleRegistry.registerModules([
  ClientSideRowModelModule, 
  ColumnMenuModule,
  ContextMenuModule, 
  ExcelExportModule, 
  ServerSideRowModelModule,
  ClipboardModule,
  ColumnsToolPanelModule,
  FiltersToolPanelModule,
  CellSelectionModule,
  RichSelectModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  SetFilterModule,
  MultiFilterModule,
  SideBarModule,
  StatusBarModule,
  CsvExportModule,
  AdvancedFilterModule,
  IntegratedChartsModule.with(AgChartsEnterpriseModule),
  ValidationModule,
  ColumnAutoSizeModule,
  ColumnApiModule,
  DateFilterModule,
  CellStyleModule,
  TextFilterModule,
  NumberFilterModule,
  ServerSideRowModelApiModule,
  RowApiModule,
  PaginationModule,
  PinnedRowModule,
  RowAutoHeightModule,
  EventApiModule,
  TextEditorModule,
  LargeTextEditorModule,
  CustomEditorModule,
  SelectEditorModule,
  RowSelectionModule,
  ExternalFilterModule,
  ClientSideRowModelApiModule,
  QuickFilterModule,
  PivotModule,
  RenderApiModule,
  LocaleModule,
  CellApiModule,
  RowDragModule,
  InfiniteRowModelModule,
  UndoRedoEditModule,
  BatchEditModule,
  RowStyleModule,
  RowStyleModule,
  ScrollApiModule,
  GridStateModule
]);

import { 
  parseInteger,
  parseDecimal,
  parseBoolean,
  parseDate,
  parseTimestamp,
  parseString,
  parseCoordinate
} from '../../../helpers/parsers.js';

// Rename newValue to match the API of parsers
const integerParser = ({newValue, ...rest}) => parseInteger({value: newValue, ...rest});
const booleanParser = ({newValue, ...rest}) => parseBoolean({value: newValue, ...rest});
const decimalParser = ({newValue, ...rest}) => parseDecimal({value: newValue, ...rest});
const stringParser = ({newValue, ...rest}) => parseString({value: newValue, ...rest});
const dateParser = ({newValue, ...rest}) => parseDate({value: newValue, ...rest});
const timestampParser = ({newValue, ...rest}) => parseTimestamp({value: newValue, ...rest});
const coordinateParser = ({newValue, ...rest}) => parseCoordinate({value: newValue, ...rest})

LicenseManager.setLicenseKey("Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-074776}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Adalia_Oy}_is_granted_a_{Multiple_Applications}_Developer_License_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Charts_and_AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{14_March_2026}____[v3]_[0102]_MTc3MzQ0NjQwMDAwMA==5914f2b97181ff7d6ba232041e3a0032")

import './theme.css';
import {formatNumber, roundNumber} from '../FormattedNumber.jsx';
import DateTimeCellEditor from './DateTimeCellEditor.jsx';
import CoordinateCellEditor from './CoordinateCellEditor.jsx';
import CellRenderer from './CellRenderer.jsx';
import CustomTextCellEditor from './CustomTextCellEditor.jsx';
import ProjectLinkCellRenderer, { valueGetter as projectValueGetter, filterGetter as projectFilterGetter } from './ProjectLinkCellRenderer.jsx';
import MonitoringReportLinkCellRenderer, { valueGetter as sourceValueGetter, filterGetter as sourceFilterGetter } from './MonitoringReportLinkCellRenderer.jsx';
import ConnectedUsersLinkCellRenderer, {valueGetter as connectedUsersValueGetter} from './ConnectedUsersLinkCellRenderer.jsx';
import { valueGetter as serialNumberValueGetter, valueFormatter as serialNumberValueFormatter, validateSelectionCell as serialNumberValidateSelectionCell } from './SerialNumberCellRenderer.jsx';
import { valueGetter as coordinateValueGetter, valueFormatter as coordinateValueFormatter, validateCoordinate } from './CoordinateCellRenderer.jsx';
import SparklineCellRenderer, { validateSparklineCell } from './SparklineCellRenderer.jsx';
import { ChangeTrackingCellRenderer } from './ChangeTrackingCellRenderer.jsx';
import {valueFormatter as computedMatchValueFormatter} from './ComputedMatchCellRenderer.jsx';
import { getFilteredOptionSetOptions, OptionSetCellRenderer, optionSetValueFormatter, validateOptionSet } from './OptionSetCellRenderer.jsx';
import UserChoiceCellEditor, {valueFormatter as userChoiceValueFormatter} from './UserChoiceCellEditor.jsx';
import ProjectSelectCellEditor from './ProjectSelectCellEditor.jsx';

// Doc: https://www.ag-grid.com/javascript-data-grid/server-side-model-selection/
// Reason: Because all nodes may not be loaded yet, getServerSideSelectionState get all nodes as they're loaded
export const getServerSideSelectedNodes = (params) => {
  const nodeIds = (params.api.getServerSideSelectionState()?.toggledNodes || []).map(n => n.nodeId)
  let nodes = []
  params.api.forEachNode((node) => {
    if (nodeIds.includes(node.id)){
      nodes.push(node)
    }
  })
  return nodes
}


export const numberFormatter = (params) => {
  if (params.value == null) return ''; // Anything else should already be cleaned up by parsers
  if (typeof params.value == 'string') { return params.value }; // Error string added by parser

  let value = preDefinedValueFormatter(params);
  const { decimal_places = null } = params.colDef?.cellRendererParams?.original || {};
  if (decimal_places != null) {
    value = Number(value).toFixed(decimal_places);
  };
  return formatNumber(value)
};

const preDefinedValueFormatter = (params) => {
  let {value} = params;
  let {has_dependency = false, dependency_settings = {}} = params.colDef?.cellRendererParams?.original;

  if (!has_dependency) {
    return value; // return if there is no dependency
  }

  switch (dependency_settings['value_formatter']) {
    case 'negativeValueFormatter':
      return value > 0 ? -value : value;
    case 'positiveValueFormatter':
      return Math.abs(value);
    default:
      return value;
  }
};

// TODO: Change .local() for project timezone ?
export const dateFormatter = (params, format) => {
  if (!params?.data) return null;

  const value = params.data[params.colDef.field];
  const dateStr = typeof value === 'object' && value?.label ? value.label : value;
  if (!dateStr) return null;

  const parsed = parseZone(dateStr);
  if (!parsed.isValid()) return null;
  return parsed.format(format);
};

export const getLocaleText = (params) => {
  const translationKey = `${(params.key || 'no_key_provided')
    .replace(/([A-Z])/g, '_$1')
    .toLowerCase()}`;

  const interpolation = params.variableValues && params.variableValues.length
    ? params.variableValues.reduce((acc, value, index) => {
        acc[`variable${index + 1}`] = value;
        return acc;
      }, {})
    : {};

  const result = I18n.t(translationKey, {scope: 'ag_translations'}, { ...interpolation });

  return result;
};

export const commonGridOptions = {
  // localeText: {
  //   noRowsToShow: I18n.t('no_rows_to_show', {scope: 'ag_translations'}),
  // },
  onModelUpdated: (params) => {
    const {api} = params;
    const hasRows = api.getDisplayedRowCount() > 0;

    if (hasRows) {
      api.hideOverlay();
    } else {
      api.showNoRowsOverlay();
    }
  },
};

const validateNumber = (props) => {
  const valid = props.value == null || typeof props.value == 'number';
  props.data ||= {};
  if ((props.data.formula_errors||{}).hasOwnProperty(props.column.colId)){
    return false;
  }
  // TODO: Fix prop mutating. Why is this here? Commented for now as throws errors
  // if (typeof props.data.datagridValidData !== 'object'){
  //   props.data.datagridValidData = {}
  // }
  // props.data.datagridValidData[props.column.colId] = valid || props.value == undefined  //Shouldn't mutate props
  return valid
};

const validateText = ({ data = {}, column }) => {
  const errors = data.formula_errors || {};
  return !errors.hasOwnProperty(column.colId);
};

export const DATA_TYPE_PROP_MAP = {
  'integer': {
    filter: 'agNumberColumnFilter', 
    cellEditor: CustomTextCellEditor,
    cellRenderer: CellRenderer,
    valueParser: integerParser,
    enableValue: true,
    cellClass: 'align-right monospace',
    valueFormatter: numberFormatter,
    cellRendererParams: {
      validate: validateNumber,
    },
    cellDataType: 'number'
  },
  'boolean': {
    filter: 'agSetColumnFilter',
    filterParams: {
      values: [true, false],
      valueFormatter: ({value}) => I18n.t(value.toString())
    },
    cellEditor: 'agSelectCellEditor',
    cellEditorParams: {
      values: [true, false],
    },
    valueFormatter: (params) => typeof params.value == 'boolean' ? I18n.t(params.value.toString()) : null,
    valueParser: booleanParser
  },
  'decimal': {
    filter: 'agNumberColumnFilter',
    cellEditor: CustomTextCellEditor,
    cellRenderer: CellRenderer,
    valueParser: decimalParser,
    enableValue: true,
    cellClass: 'align-right monospace',
    valueFormatter: numberFormatter,
    cellRendererParams: {
      validate: validateNumber,
    },
    cellDataType: 'number'
  },
  'text': {
    filter: 'agTextColumnFilter', 
    cellEditor: 'agTextCellEditor',
    cellRenderer: CellRenderer,
    enableRowGroup: true,
    enableValue: true,
    allowedAggFuncs: ['first', 'last'],
    defaultAggFunc: 'last',
    valueParser: stringParser,
    cellRendererParams: {
      validate: validateText,
    },
  },
  'long_text': {
    filter: 'agTextColumnFilter', 
    cellEditor: 'agLargeTextCellEditor',
    cellEditorPopup: true,
    valueParser: stringParser,
  },
  'date': {
    filter: 'agDateColumnFilter', 
    cellEditor: DateTimeCellEditor,
    cellEditorPopup: true,
    cellEditorParams: {format: 'YYYY-MM-DD'},
    valueGetter: (params) => dateFormatter(params, 'YYYY-MM-DD'),
    valueParser: dateParser,
    enableValue: true,
    cellDataType: 'dateString',
    cellRenderer: ({value}) => DT.dt(value),
  },
  'timestamp': {
    filter: 'agDateColumnFilter', 
    cellEditor: DateTimeCellEditor,
    cellEditorPopup: true,
    cellEditorParams: {format: 'YYYY-MM-DDTHH:mm:ssZ', altInput: true, altFormat: 'YYYY-MM-DDTHH:mm:ssZ'},
    valueGetter: (params) => dateFormatter(params, 'YYYY-MM-DDTHH:mm:ssZ'),
    valueParser: timestampParser,
    valueFormatter: (params) => dateFormatter(params, 'YYYY-MM-DD HH:mm Z'),
    cellRenderer: ({value}) => DT.dt(value, {datetime: true}),
  },
  // TODO: Move to datagrid specific place
  'status': {
    editable: false,
    enableRowGroup: true,
    cellStyle: ({ value }) => {
      switch (value) {
        case "approved":
          return {color: "#155724", backgroundColor: "#d4edda", borderColor: "#c3e6cb"}
        case "rejected":
          return {color: "#721c24", backgroundColor: "#f8d7da", borderColor: "#f5c6cb"}
        case "reverted":
          return {color: "#564315", backgroundColor: "#ede5d4", borderColor: "#e5dbc2"}
        case "submitted":
          return {color: "#153d56", backgroundColor: "#d4e3ed", borderColor: "#c2d7e5"}
        case "locked":
          return {color: "#383d41", backgroundColor: "#e2e3e5", borderColor: "#d6d8db"}
        default:
          break;
      }
    },
    tooltipValueGetter: (params) => {
      let displayTooltip = ['submitted', 'approved'].includes(params.value);
      return displayTooltip ? I18n.t('datagrid_row_cannot_be_edited', {status: I18n.t(params.value)}) : null;
    }
  },
  'recorded_at': {
    editable: false,
    filter: 'agDateColumnFilter', 
    valueGetter: (params) => dateFormatter(params, 'YYYY-MM-DD HH:mm Z'),
    cellRenderer: ({value}) => DT.dt(value, {datetime: true}),
  },
  'last_modified_at': {
    editable: false,
    filter: 'agDateColumnFilter', 
    valueGetter: (params) => dateFormatter(params, 'YYYY-MM-DD HH:mm Z'),
    cellRenderer: ({value}) => DT.dt(value, {datetime: true}),
  },
  'project': {
    editable: false,
    filter: 'agTextColumnFilter', 
    cellRenderer: ProjectLinkCellRenderer,
    cellEditor: ProjectSelectCellEditor,
    valueGetter: projectValueGetter,
    valueParser: (params) => params.newValue,
    //filterValueGetter: projectFilterGetter,
    enableRowGroup: true
  },
  'source': {
    editable: false,
    filter: 'agTextColumnFilter', 
    cellRenderer: MonitoringReportLinkCellRenderer,
    valueGetter: sourceValueGetter,
    //filterValueGetter: sourceFilterGetter,
    enableRowGroup: true
  },
  'last_modified_by': {
    editable: false,
    filter: 'agTextColumnFilter', 
    enableRowGroup: true,
    valueGetter: (params) => {
      return (params.data[params.colDef.field] || {})["label"]
    },
  },
  'percentage_over': {
    editable: false,
    sortable: true,
    cellClass: 'align-right monospace',
    cellDataType: 'number',
    defaultAggFunc: 'avg',
    valueFormatter: (params) => params.value ||  params.value == 0 ? formatNumber(roundNumber(parseFloat(params.value * 100),2)) + '%' : ''
  },
  'milestone': {
    enableRowGroup: true,
    filter: 'agTextColumnFilter',
    valueGetter: serialNumberValueGetter,
    valueFormatter: serialNumberValueFormatter,
    cellRendererParams: {
      validate: serialNumberValidateSelectionCell
    }
  },
  'datagrid_reference': {
    enableRowGroup: true,
    filter: 'agTextColumnFilter',
    valueGetter: serialNumberValueGetter,
    valueFormatter: serialNumberValueFormatter,
    cellRendererParams: {
      validate: serialNumberValidateSelectionCell
    },
    filterParams: {
      valueFormatter: serialNumberValueFormatter
    }
  },
  'serial_number': {
    editable: false,
    enableRowGroup: true,
    filter: 'agTextColumnFilter',
    valueGetter: serialNumberValueGetter,
    valueFormatter: serialNumberValueFormatter,
    cellRendererParams: {
      validate: serialNumberValidateSelectionCell
    }
  },
  'coordinate': {
    enableRowGroup: true,
    valueFormatter: coordinateValueFormatter,
    valueParser: coordinateParser,
    valueGetter: coordinateValueGetter,
    cellEditorPopup: true,
    cellEditor: CoordinateCellEditor,
    cellRendererParams: {
      validate: validateCoordinate
    },
    filter: 'agTextColumnFilter', // Improve this filter
  },
  'sparkline': {
    editable: false,
    cellRenderer: SparklineCellRenderer,
    cellClass: 'align-right monospace',
    cellRendererParams: {
      validate: validateSparklineCell
    }
  },
  'change_tracking': {
    editable: false,
    cellRenderer: ChangeTrackingCellRenderer,
    cellClass: 'align-right monospace',
    valueGetter: (params) => {
      const date = dateFormatter(params, 'YYYY-MM-DD')
      return { ...(params.data || {})[params.colDef.field], timestamp: date }
    },
  },
  'computed_match': {
    editable: false,
    enableRowGroup: true,
    filter: 'agSetColumnFilter',
    filterParams: {
      values: [true, false],
      valueFormatter: computedMatchValueFormatter
    },
    valueFormatter: computedMatchValueFormatter,
    valueParser: booleanParser,
    enableValue: true,
    allowedAggFuncs: ['first', 'last']
  },
  'option_set': {
    enableRowGroup: true,
    filter: 'agSetColumnFilter',
    filterParams: {
      valueFormatter: optionSetValueFormatter
    },
    cellEditorParams: params => ({
      values: getFilteredOptionSetOptions(params).map(o => o.value)
    }),
    cellRendererParams: {
      validate: validateOptionSet,
      getOptions: getFilteredOptionSetOptions
    },
    valueFormatter: optionSetValueFormatter,
    cellRenderer: OptionSetCellRenderer
  },
  'connected_users': {
    editable: false,
    sortable: false,
    filter: 'agTextColumnFilter',
    cellRenderer: ConnectedUsersLinkCellRenderer,
    valueGetter: connectedUsersValueGetter,
    enableRowGroup: true
  },
  'user_choice': {
    valueFormatter: userChoiceValueFormatter,
    cellEditorPopup: true,
    cellEditor: UserChoiceCellEditor,
    cellRendererParams: {},
    filter: 'agTextColumnFilter',
    filterParams: {
      valueFormatter: userChoiceValueFormatter,
    }
  },
};

export const DATA_TYPE_DEFINITIONS = {
  dataTypeDefinitions: {
    // override `date` to handle custom date format `YYYY-MM-DD`
    date: {
      baseDataType: 'dateString',
      extendsDataType: 'dateString',
      valueParser: dateParser,
      valueFormatter: (params) => dateFormatter(params, 'YYYY-MM-DD')
    }
  }
};

export const defaultExcelExportParams = {
  sheetName: I18n.t('export')
};

const AgGrid = React.forwardRef((props, ref) => <AgGridReact theme={gridTheme} {...commonGridOptions} {...{defaultExcelExportParams, ...props}} ref={ref}/>)

/*
  The default layout, must provide height for wrapperStyle to display table correctly
*/
export const AgGridWrapper = React.forwardRef(({children, wrapperStyle, className = '', ...rest}, ref) => (
  <div 
      className={`grid-theme ${className}`}
      style={{
        width: '100%', 
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        paddingBottom: '1rem',
        ...(wrapperStyle || {})
      }}
      {...rest}
      ref={ref}
    >{children}</div>
));

export default AgGrid;